module.exports = __webpack_public_path__ + "static/media/55_000082.a2b3934d.jpg";